import React from 'react';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {connect} from 'react-redux';
import AppointmentsTable from './appointmentsTable';
import { withStyles } from '@material-ui/core/styles';

const styles={
    headLine:{
        fontSize: 30,
        fontWeight:500
    }
};

class Appointments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div className='container-div'>
                <ContentGrid
                    content={
                        <Card
                            header={'Appointments'}
                            CardHeaderProps={{
                                classes: {
                                    title:classes.headLine
                                }
                            }}
                            content={
                                <AppointmentsTable/>
                            }
                            CardContentProps={{
                                style: {borderTop: '1px solid #ddd'}
                            }}
                        />
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.loginResponse
    }
};
export default connect(mapStateToProps, null)(withStyles(styles)(Appointments));